import { readNetwork } from '../Reels/network'

/** a slow link gets half the poster: it shows only until the first frame */
const POSTER_WIDTH_FAST = 720
const POSTER_WIDTH_SLOW = 360

/** the poster width for this visitor: a 4g link (or Safari, which gives no hint) is the fast one */
export const posterWidth = () =>
  readNetwork().preloadAdMedia ? POSTER_WIDTH_FAST : POSTER_WIDTH_SLOW

/**
 * A frame from inside the clip (its first frame is often black). Quality 70
 * halves the file (720px: 77KB to 42KB) with no visible change. The viewer and
 * the rail's warm-up use this same url, so a warmed poster comes from the cache.
 */
export const kalturaPoster = (kalturaId: string, width: number) =>
  `https://cfvod.kaltura.com/p/2748741/sp/274874100/thumbnail/entry_id/${kalturaId}/width/${width}/vid_sec/1/quality/70`
